import * as Yup from 'yup';
import { omit } from 'lodash';

import { OptionType } from '@/typings/common';

import {
  ConsultationFormSecondaryFieldsConfig,
  ConsultationFormSecondaryFieldsSchema,
} from './types';

export const getDealersOptions = (
  dealers: { dealer: OptionType; brands: OptionType[] }[]
): OptionType[] => {
  return dealers.map((dealerItem) => ({
    label: dealerItem.dealer.label,
    value: dealerItem.dealer.value,
  }));
};

export const getDealersOptionsByBrand = (
  dealers: { dealer: OptionType; brands: OptionType[] }[],
  searchBrand: string
): OptionType[] => {
  return dealers
    .filter((dealer) =>
      dealer.brands.some((brand) => brand.value === searchBrand)
    )
    .map((dealerItem) => ({
      label: dealerItem.dealer.label,
      value: dealerItem.dealer.value,
    }));
};

export const getResultConsultationFormSecondaryValues = (
  values: ConsultationFormSecondaryFieldsSchema,
  fieldsConfig?: ConsultationFormSecondaryFieldsConfig
) => {
  const paths: Array<keyof ConsultationFormSecondaryFieldsSchema> = [];

  if (!fieldsConfig?.withBrands) {
    paths.push('brand');
  }

  if (!fieldsConfig?.withDealers) {
    paths.push('dealer');
  }

  if (!fieldsConfig?.withMessage) {
    paths.push('message');
  }

  return omit(values, paths) as ConsultationFormSecondaryFieldsSchema;
};

export const getDefaultValues = (
  options: {
    dealers: OptionType[];
  },
  fieldsConfig?: ConsultationFormSecondaryFieldsConfig
): ConsultationFormSecondaryFieldsSchema => {
  const dealer =
    fieldsConfig?.withDealers &&
    options?.dealers &&
    options.dealers.length === 1
      ? options.dealers[0]
      : initialConsultationFormSecondaryValues.dealer;

  return {
    ...initialConsultationFormSecondaryValues,
    dealer,
  };
};

export const initialConsultationFormSecondaryValues: ConsultationFormSecondaryFieldsSchema =
  {
    name: '',
    phone: '',
    brand: { label: '', value: '' },
    dealer: { label: '', value: '' },
    message: '',
  };

export const validationConsultationFormSecondarySchema = (
  fieldsConfig?: ConsultationFormSecondaryFieldsConfig
): Yup.SchemaOf<ConsultationFormSecondaryFieldsSchema> => {
  return Yup.object().shape({
    name: Yup.string().required('Укажите имя'),
    phone: Yup.string().required('Укажите номер телефона'),
    brand: Yup.object({
      label: Yup.string(),
      value: Yup.string(),
    }).when([], {
      is: () => fieldsConfig?.withBrands,
      then: Yup.object({
        label: Yup.string().required('Выберите марку автомобиля'),
        value: Yup.string().required('Выберите марку автомобиля'),
      }),
      otherwise: Yup.object({
        label: Yup.string().notRequired(),
        value: Yup.string().notRequired(),
      }),
    }),
    dealer: Yup.object({
      label: Yup.string(),
      value: Yup.string(),
    }).when([], {
      is: () => fieldsConfig?.withDealers,
      then: Yup.object({
        label: Yup.string().required('Выберите автоцентр'),
        value: Yup.string().required('Выберите автоцентр'),
      }),
      otherwise: Yup.object({
        label: Yup.string().notRequired(),
        value: Yup.string().notRequired(),
      }),
    }),
    message: Yup.string(),
  }) as Yup.SchemaOf<ConsultationFormSecondaryFieldsSchema>;
};
